import { toAbsoluteUrl } from "../toAbsoluteUrl";
export default function Pagination(props) {
  return (
    <div className="d-flex justify-content-between pt-4 pb-5 pagination-main-div">
      {props.countOfStudents > 10 &&
      <div className="d-flex gap-3 align-items-center">
        <p>
          {props.limit} of {props.countOfStudents} Showing
        </p>
        <select
          class=" select-of-number"
          aria-label="Default select example"
          value={props.limit}
          onChange={(event) => {
            props.setPage(1);
            props.setLimit(event.target.value);
          }}
        >
          <option selected value="10">
            10
          </option>
          <option value="30">30</option>
          <option value="50">50</option>
          <option value="100">100</option>
        </select>
      </div>}
      {props.countOfStudents > 10 &&
      <div className="pagination-arrows">
        <div
          className={`previous-page ${props.prev == 0 ? "disabled" : ""}`}
          onClick={
            props.prev !== 0
              ? () => props.setPage(props.currentPage - 1)
              : undefined
          }
        >
          <img
          className="notDark"
            src={toAbsoluteUrl("/media/images/arrow-left.svg")}
            alt="action-icon"
          />
          <img
          className="darkMode"
            src={toAbsoluteUrl("/media/images/arrow-left-dark.svg")}
            alt="action-icon"
          />
          <p>Previous</p>
        </div>
        <div
          className={`next-page ${props.next == 0 ? "disabled" : ""}`}
          onClick={
            props.next !== 0
              ? () => props.setPage(props.currentPage + 1)
              : undefined
          }
        >
          <p>Next</p>
          <img
          className="notDark"
            src={toAbsoluteUrl("/media/images/arrow-left.svg")}
            alt="action-icon"
          />
          <img
          className="darkMode"
            src={toAbsoluteUrl("/media/images/arrow-left-dark.svg")}
            alt="action-icon"
          />
        </div>
      </div>}
    </div>
  );
}
